
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import CheckListPrint from "./check-list-print.vue";
import DelegatePrint from "./delegate-print.vue";
const testingItem = namespace("testing-item");
import t from "@common/src/i18n/t";

const app = namespace("app");
const base = namespace("base");

@Component({
  components: { CheckListPrint, DelegatePrint }
})
export default class PrintDropdown extends Vue {
  @testingItem.Action getTestOrderDetail;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @base.Action jumpPrintPage;
  @Prop({ type: Object, default: () => {} })
  detailData: any;
  @Prop({ type: String, default: "button" }) // button text
  triggerStyleType: string;
  @Prop({ type: Boolean, default: false })
  isGetDetail: any;
  showDelegatePrint = false;
  getData = false;

  handleCopyMenuClick(command) {
    if (command === "printCheck") {
      this.jumpPrintPage({
        category: "PRINT_CHECK_ORDER",
        documentNo: this.detailData.checkOrderNo
      });
    } else if (command === "printDelegate") {
      this.jumpPrintPage({
        category: "PRINT_CHECK_DELEGATION_CREDENTIALS",
        documentNo: this.detailData.checkOrderNo
      });
    }
  }
  delegatePrintObj: any = {
    id: "printMer2",
    popTitle: t("service.order-ticket"),
    extraCss: "",
    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
  };
  missDetailData: any = {};
}
